import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
// core components
import NavPills from "components/NavPills/NavPills.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import MUIDataTable from "mui-datatables";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchVesselnew2,
  fetchPOI2,
  fetchPoiSearch,
  fetchVesselSearch,
  fetchFleetPtmSource,
  fetchPtmFleetSearch,
  fetchPtmGpsapirtSearch
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import {
  pushPoiTarget,
  pushPortTarget,
  pushSourceAis,
  pushShipTrack
} from "actions/portal";

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  }
});

class Monitoring extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      datatable2: [],
      datatable3: [],
      source: ""
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ source: nextProps.sourceAis });
    if (nextProps.sourceAis !== this.props.sourceAis) {
      fetchFleetPtmSource(nextProps.sourceAis)
        .then(response => {
          this.setState({ datatable3: response.data.results });
        })
        .catch(error => {
          console.log(error);
          this.props.history.push("/pages/login#logout");
        });
    }
  }

  getDatatable_port = search => {
    fetchPoiSearch(search)
      .then(response => {
        if (response != null) {
          this.setState({ datatable2: response.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  getDatatable_vessel = search => {
    fetchVesselSearch(search)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  getDatatable_fleetptm = search => {
    if (this.props.sourceAis === "AIS_MT" || this.state.source === "AIS_MT") {
      fetchPtmFleetSearch(search)
        .then(response => {
          if (response != null) {
            this.setState({ datatable3: response.data.results });
          }
        })
        .catch(error => {
          //this.props.pushToken(error);
          this.props.history.push("/pages/login#logout");
        });
    } else {
      fetchPtmGpsapirtSearch(search)
        .then(response => {
          if (response != null) {
            this.setState({ datatable3: response.data.results });
          }
        })
        .catch(error => {
          //this.props.pushToken(error);
          this.props.history.push("/pages/login#logout");
        });
    }
  };

  handleChange = e => {
    this.setState({ search: e.target.value });
    this.getDatatable_vessel(e.target.value);
    this.getDatatable_port(e.target.value);
    this.getDatatable_fleetptm(e.target.value);
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "course",
        label: "Course",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "elapsed",
        label: "Elapsed",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "heading",
        label: "Heading",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "lat",
        label: "Lat",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "lon",
        label: "Lon",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "shipname",
        label: "Shipname",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "ship_id",
        label: "ID",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "speed",
        label: "Speed Returned in (knots x10)",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "status_name",
        label: "Status",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "type_img",
        label: "Type Img",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "type_name",
        label: "Type Name",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "country_code",
        label: "Country Code",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "reported_draught",
        label: "Reported Draught",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dest_class",
        label: "Dest Class",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "port_data_x",
        label: "Port Data X",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "port_data_y",
        label: "Port Data Y",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_pos",
        label: "Last Pos",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_pos_tooltip",
        label: "Last Pos Tooltip",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "timezone_offset",
        label: "Timezone Offset",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "show_load_status",
        label: "Show Load Status",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "vsl_length",
        label: "Vsl Length",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "vsl_code",
        label: "Vsl Code",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "mmsi",
        label: "MMSI",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "imo",
        label: "IMO",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "type_summary",
        label: "Type Summary",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "country",
        label: "Country",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dwt",
        label: "DWT",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "rot",
        label: "ROT",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "destination",
        label: "Destination",
        options: {
          filter: true,
          display: true
        }
      },
      {
        name: "width",
        label: "Width",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "length",
        label: "Length",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "flag",
        label: "Flag",
        options: {
          filter: true,
          display: true
        }
      },
      {
        name: "draught",
        label: "Draught",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_id",
        label: "Last Port Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_name",
        label: "Last Port Name",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_country",
        label: "Last Port Country",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_unlocode",
        label: "Last Port Unlocode",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_id",
        label: "Next Port Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_name",
        label: "Next Port Name",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_country",
        label: "Next Port Country",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_unlocode",
        label: "Next Port Unlocode",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "station_id",
        label: "Station Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "date_created",
        label: "Date Created",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "source_api",
        label: "Source Api",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() => {
                    this.props.pushShipTrack([]);
                    this.props.pushPoiTarget([
                      tableMeta.rowData[3],
                      tableMeta.rowData[4],
                      tableMeta.rowData[5],
                      tableMeta.rowData[2],
                      tableMeta.rowData[6],
                      tableMeta.rowData[0],
                      tableMeta.rowData[1],
                      tableMeta.rowData[7],
                      tableMeta.rowData[8],
                      tableMeta.rowData[29],
                      tableMeta.rowData[30],
                      tableMeta.rowData[31],
                      tableMeta.rowData[27],
                      tableMeta.rowData[28],
                      tableMeta.rowData[32],
                      tableMeta.rowData[43],
                      tableMeta.rowData[9],
                      tableMeta.rowData[10],
                      tableMeta.rowData[11]
                    ]);
                  }}
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const columns3 = [
      {
        name: "course",
        label: "Course",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "elapsed",
        label: "Elapsed",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "heading",
        label: "Heading",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "lat",
        label: "Lat",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "lon",
        label: "Lon",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "shipname",
        label: "Shipname",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "ship_id",
        label: "ID",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "speed",
        label: "Speed Returned in (knots x10)",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "status_name",
        label: "Status",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "type_img",
        label: "Type Img",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "type_name",
        label: "Type Name",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "country_code",
        label: "Country Code",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "reported_draught",
        label: "Reported Draught",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dest_class",
        label: "Dest Class",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "port_data_x",
        label: "Port Data X",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "port_data_y",
        label: "Port Data Y",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_pos",
        label: "Last Pos",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_pos_tooltip",
        label: "Last Pos Tooltip",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "timezone_offset",
        label: "Timezone Offset",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "show_load_status",
        label: "Show Load Status",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "vsl_length",
        label: "Vsl Length",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "vsl_code",
        label: "Vsl Code",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "mmsi",
        label: "MMSI",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "imo",
        label: "IMO",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "type_summary",
        label: "Type Summary",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "country",
        label: "Country",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dwt",
        label: "DWT",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "draught",
        label: "Draught",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_id",
        label: "Last Port Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_name",
        label: "Last Port Name",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_country",
        label: "Last Port Country",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "last_port_unlocode",
        label: "Last Port Unlocode",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_id",
        label: "Next Port ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_name",
        label: "Next Port Name",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_country",
        label: "Next Port Country",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "next_port_unlocode",
        label: "Next Port Unlocode",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "station_id",
        label: "Station ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "date_created",
        label: "Date Created",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "rot",
        label: "ROT",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "destination",
        label: "Destination",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "width",
        label: "Width",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "length",
        label: "Lenght",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "flag",
        label: "Flag",
        options: {
          filter: true,
          display: true
        }
      },
      {
        name: "source",
        label: "Source",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "call_sign",
        label: "Call Sign",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "programer_id",
        label: "Programer ID",
        options: {
          filter: true,
          display: false
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() => {
                    this.props.pushPoiTarget([
                      tableMeta.rowData[3],
                      tableMeta.rowData[4]
                    ]);
                    this.props.pushShipTrack([]);
                  }}
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const columns2 = [
      {
        name: "gid",
        label: "GID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "address",
        label: "Address",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "district",
        label: "District",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "subdistrict",
        label: "Subdistrict",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "id_district",
        label: "ID District",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "id_subdistrict",
        label: "ID Subdistrict",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dimensi",
        label: "Dimensi",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "subdimensi",
        label: "Subdimensi",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "category",
        label: "Category",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "description",
        label: "Description",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "imgpath",
        label: "Imgpath",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "iconpath",
        label: "Iconpath",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "sorting",
        label: "Sorting",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() => {
                    this.props.pushShipTrack([]);
                    this.props.pushPortTarget([
                      tableMeta.rowData[15],
                      tableMeta.rowData[14]
                    ]);
                  }}
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      search: false,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "simple",
      viewColumns: true
    };

    const options2 = {
      filter: false,
      search: false,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "simple",
      viewColumns: true
    };

    const options3 = {
      filter: false,
      search: false,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "simple",
      viewColumns: true
    };

    return (
      <GridItem xs={12}>
        <div className={classes.content}>
          <CustomInput
            labelText="Search"
            id="search"
            inputProps={{
              value: this.state.search,
              onChange: this.handleChange
            }}
            formControlProps={{
              fullWidth: true
            }}
          />
          <NavPills
            color="info"
            alignCenter={true}
            tabs={[
              {
                tabButton: "Pertamina Fleet",
                tabContent: (
                  <MUIDataTable
                    data={this.state.datatable3}
                    columns={columns3}
                    options={options3}
                  />
                )
              },
              {
                tabButton: "Vessel",
                tabContent: (
                  <MUIDataTable
                    data={this.state.datatable}
                    columns={columns}
                    options={options}
                  />
                )
              },

              {
                tabButton: "Port",
                tabContent: (
                  <MUIDataTable
                    data={this.state.datatable2}
                    columns={columns2}
                    options={options2}
                  />
                )
              }
            ]}
          />
        </div>
      </GridItem>
    );
  }
}

Monitoring.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushPoiTarget: PropTypes.array,
  pushPortTarget: PropTypes.array,
  pushShipTrack: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel,
    sourceAis: state.sourceAis
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushPoiTarget, pushPortTarget, pushSourceAis, pushShipTrack }
)(withStyles(styles)(Monitoring)));
